// extracted by mini-css-extract-plugin
module.exports = {"projects":"FeaturedProjects_projects__lUxz1","projectsMobile":"FeaturedProjects_projectsMobile__trK2Y"};